function getSlideNumberInType(slides, slide) {
    return slides
        .filter(current => current.component === slide.component)
        .findIndex(current => current.id === slide.id) + 1;
}

export {
    getSlideNumberInType
};
